export const CyLoadingMessage = {
  LoadingText: "LoadingText",
} as const;
